// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2518":"32ad7913","3135":"8db357b2"}[chunkId] + ".chunk.css";
};